// extracted by mini-css-extract-plugin
export default {"loader":"ScrollLoder_loader__lLFQq","bar":"ScrollLoder_bar__8oZhA","scale-up4":"ScrollLoder_scale-up4__vFZEa"};